// src/pages/Examiner/ExaminerLayout.js
import React, { useContext } from 'react';
import { Outlet } from 'react-router-dom';
import SidebarAccordion from '../../components/SidebarAccordion';
import { SidebarContext } from '../../context/SidebarContext';
import PageLayout from '../PageLayout';
import './ExaminerLayout.css';
import { FaTasks, FaChartBar } from 'react-icons/fa';

function ExaminerLayout() {
  const { sidebarOpen } = useContext(SidebarContext);

  const menuItems = [
    {
      title: 'Jobs',
      icon: <FaTasks />,
      children: [
        { title: 'Dashboard', path: '/examiner/jobs', icon: <FaTasks /> }
      ],
    },
    {
      title: 'Reports',
      icon: <FaChartBar />,
      children: [
        { title: 'Examiner Reports', path: '/examiner/reports', icon: <FaChartBar /> }
      ],
    },
  ];

  return (
    <div className="examiner-layout">
      <div className={`examiner-layout-body ${sidebarOpen ? 'sidebar-open' : ''}`}>
        <SidebarAccordion menuItems={menuItems} />
        <div className="main-content">
          <PageLayout>
            <Outlet />
          </PageLayout>
        </div>
      </div>
    </div>
  );
}

export default ExaminerLayout;
